import React from 'react';
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const DashboardMobileHeaderActions = ({
    classes,
    urlArray,
    userData,
    languageAnchorEl,
    profileAnchorEl,
    openLanguageMenu,
    closeLanguageMenu,
    openProfileMenu,
    closeProfileMenu,
    onLanguagePick,
    onLogoutClick,
    translate,
    headerUserIconPath,
    headerTextColorMobile,
    headerArrowColorMobile,
    connectedCustomers,
    selectedCustomer,
    onCustomerSwitch
}) => {

    const handlePick = (customerId) => {
        closeProfileMenu();
        onCustomerSwitch(customerId);
    };

    return (
        <>
            <IconButton onClick={openLanguageMenu} size="small">
                <img
                    className={classes.appBarToolbarLanguageMobile}
                    src={urlArray[1] === 'se' ? '/se.png' : '/gb.png'}
                    alt="language"
                />
                <ArrowDropDownIcon style={{ color: headerArrowColorMobile || '#fff' }}/>
            </IconButton>

            <Menu
                anchorEl={languageAnchorEl}
                open={Boolean(languageAnchorEl)}
                onClose={closeLanguageMenu}
                keepMounted
            >
                {urlArray[1] === 'se' && (
                    <MenuItem onClick={() => onLanguagePick({ lang: 'en', code: 'en-US' })}>
                        <img src="/gb.png" alt="en" style={{ marginRight: 15, height: 20, width: 30 }} />
                        English
                    </MenuItem>
                )}
                {urlArray[1] === 'en' && (
                    <MenuItem onClick={() => onLanguagePick({ lang: 'se', code: 'sv-SE' })}>
                        <img src="/se.png" alt="se" style={{ marginRight: 15, height: 20, width: 30 }} />
                        Svenska
                    </MenuItem>
                )}
            </Menu>

            <IconButton onClick={openProfileMenu} size="small">
                <img
                    className={classes.appBarToolbarUserIconMobile}
                    src={headerUserIconPath || '/user.png'}
                    alt="profile"
                />
                <span className={classes.appBarToolbarUserNameMobile} style={{ color: headerTextColorMobile || '#fff' }}>
                    {userData.name || userData.email}
                </span>
                <ArrowDropDownIcon style={{ color: headerArrowColorMobile || '#fff' }} />
            </IconButton>

            <Menu
                anchorEl={profileAnchorEl}
                open={Boolean(profileAnchorEl)}
                onClose={closeProfileMenu}
                keepMounted
            >
                {connectedCustomers && connectedCustomers.length > 0 && connectedCustomers.map(customer => (
                    <MenuItem
                        key={customer.id}
                        selected={String(customer.id) === String(selectedCustomer)}
                        onClick={() => handlePick(customer.id)}
                    >
                        <ListItemText primary={customer.name} />
                    </MenuItem>
                ))}
                <MenuItem onClick={onLogoutClick}>
                    <ListItemIcon>
                        <ExitToAppIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={translate('', 'tooltip_logout')} />
                </MenuItem>
            </Menu>
        </>
    );
};

export default DashboardMobileHeaderActions;